// src/components/Topbar.js
import React, {useEffect, useState} from 'react';
import { BellIcon, UserCircleIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import NotificationBadge from "../common/NotificationBadge";
import {Bars3Icon} from "@heroicons/react/16/solid";
import {onValue, ref} from "firebase/database";
import {db} from "../../firebase"; // Example icons

const Topbar = ({ userId }) => {
    const [user, setUser] = useState("");

    useEffect(() => {
        onValue(ref(db, `localRewards/account/${userId}`), snapshot => {
            if (snapshot.exists) {
                const fullName = snapshot.child("fullName").val();
                setUser(fullName)
            }
        });
    }, [userId])

    // Placeholder for sidebar/mobile menu toggle
    const handleMenuToggle = () => {
        alert('Toggle mobile menu');
    };

    // Placeholder for search action
    const handleSearch = () => {
        alert('Perform search');
    };

    return (
        <div className="bg-white shadow-sm p-4 flex justify-between items-center z-10 sticky top-0">
            {/* Search Bar (Optional) */}
            <div className="relative flex-1 max-w-md ml-4">
                <input
                    type="text"
                    placeholder="Search..."
                    className="w-full pl-10 pr-4 py-2 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent text-gray-700"
                />
                <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            </div>

            {/* Right: User Actions & Notifications */}
            <div className="flex items-center space-x-4 mr-10">
                <NotificationBadge /> {/* Integrate the NotificationBadge here */}

                {/* User Profile Dropdown (Placeholder) */}
                <div className="relative">
                    <button
                        className="flex items-center space-x-2 text-sm font-medium text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        aria-label="User menu"
                    >
                        <img
                            className="h-8 w-8 rounded-full object-cover"
                            src="https://i.pravatar.cc/150?img=3" // Placeholder user avatar
                            alt="User Avatar"
                        />
                        <span className="hidden md:block">{user}</span>
                    </button>
                    {/* Dropdown content would go here */}
                </div>

                {/* Mobile Menu Button */}
                <button
                    onClick={handleMenuToggle}
                    className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    aria-label="Open main menu"
                >
                    <Bars3Icon className="h-6 w-6" />
                </button>
            </div>
        </div>
    );
};

export default Topbar;